import { connect } from 'react-redux';
import { fetchUsers } from '../../actions/userActions';
import EnrollModal from './EnrollModal';

export default connect(null, {
  fetchUsers,
})(EnrollModal);
